<section class="o-layout__item u-layout-grow c-card">
  <h5
    i18n="Account|title for account information @@accountInformationTitle"
    class="c-card__title"
  >
    Account Information
  </h5>
  <div id="accountinfo">
    <div class="c-card__content">
      <div class="o-layout__item u-margin-0">
        <dl class="o-list o-list__descriptive">
          <dt i18n="account.html: Tablecell with text name">Name</dt>
          <dd>{{ user.firstName }} {{ user.lastName }}</dd>
          <dt i18n="account.html: Tablecell with text package">Package</dt>
          <dd class="capitalize">{{ account.type | lsTranslate }}</dd>
          <dt i18n="account.html: Tablecell with text email">Email</dt>
          <dd>{{ user.email }}</dd>
          <dt i18n="account.html: Tablecell with text number of devices">
            Number of Devices
          </dt>
          <dd>{{ account.allowedNumberOfDevices }}</dd>
          <dt i18n="account.html: Tablecell with text user since">
            User Since
          </dt>
          <dd *ngIf="account.creationDate">
            {{ account.creationDate.format('L') }}
          </dd>
          <dt i18n="account.html: Tablecell with text product series">
            Product series
          </dt>
          <dd i18n="account.html: Tablecell with text L-Series">
            L-Series
          </dd>
          <dt i18n="account.html: Tablecell with text Account id">
            Account ID
          </dt>
          <dd>{{ companySettings.masterCompanyId || '-' }}</dd>
        </dl>
      </div>
    </div>
  </div>
</section>
